<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 45 44"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <path class="fil0" d="M39 22c0,-3 0,-5 -1,-7l4 -4 -2 -3 -2 -2 -5 2c-2,-1 -4,-2 -6,-3l-1 -5 -4 0 -3 0 -1 5c0,0 0,0 0,0l0 1 0 -1c-2,1 -4,2 -6,3l0 0 -5 -2 -2 2 -2 3 4 4 0 0 2 -3 3 -4 0 0 -3 4 -2 3 0 0c-1,2 -2,4 -2,7l-5 2 1 3 0 4 6 0 0 -1c1,3 3,4 4,6l0 0 -1 5 3 2 3 1 3 -4 0 -1c1,1 2,1 3,1 2,0 3,0 4,-1l-1 1 4 4 3 -1 3 -2 -2 -5 0 0c2,-2 3,-3 4,-6l0 1 6 0 1 -4 1 -3 -6 -2zm-6 7l0 0c0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 0,0 -1,1 -1,1 -1,2 0,0 0,0 0,0 -1,0 -1,0 -1,1 0,0 0,0 0,0 0,0 0,0 -1,0 0,0 0,0 0,0 0,0 0,1 -1,1 0,0 0,0 0,0 -2,1 -4,2 -7,2 -7,0 -12,-6 -12,-13 0,-7 5,-13 12,-13 7,0 13,6 13,13 0,2 -1,5 -2,7z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Settings',
};
</script>

<style scoped>
  .fil0 {fill:#666666;fill-rule:nonzero}
</style>
